import { Link } from "react-router-dom"
import errorImg from "@/assets/images/404.png"

function NotFound() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "100px",
      }}
    >
      <img src={errorImg} alt="" />

      <div>
        很抱歉，页面走丢了……
        <Link to="/">返回首页</Link>
      </div>
    </div>
  )
}
export default NotFound
